module.exports = __webpack_public_path__ + "static/undraw_server_status_5pbv-d6d675ca8d029d4a8a05e45c054d142e.svg";